import contactCentre from './modules/contact-centre/route-names'
import extensions from './modules/extensions/route-names'

export default {
    contactCentre,
    extensions
}
